/*@flow*/
import * as t from 'lib/t';
import Section from './templates/Section';
import AsyncTemplate from './templates/AsyncTemplate';
import TagsTemplate from './templates/Tags';
import * as loaders from 'queries/loaders';
import isEmbedded from 'lib/isEmbedded';
import StatusesTemplate from './templates/Statuses';
import RangeTemplate from './templates/RangeTemplate';

const config = {
  status: t.list(t.String).opt({
    label: 'Status',
    template: StatusesTemplate,
    filterName: 'streetscape_assets',
  }),
  assetType: t.list(t.String).opt({
    legend: 'Asset Type',
    template: AsyncTemplate,
    className: 'streetscape-asset-categories-select-field',
    placeholder: 'Select asset types',
    loadValues: (o) => loaders.assetTypeLoader(o),
  }),
  assetSubtype: t.list(t.String).opt({
    legend: 'Asset Subtype',
    template: AsyncTemplate,
    className: 'asset_subtype-select-field',
    placeholder: 'Select asset subtypes',
    loadValues: (o) => loaders.assetSubtypeLoader(o),
  }),
  tags: t.list(t.String).opt({
    label: 'Tags',
    template: TagsTemplate,
    filterName: 'streetscapeAssets',
    hideWhen: isEmbedded,
  }),
  cost: t.maybe(t.Number).opt({
    label: 'Cost',
    template: RangeTemplate,
  }),
};

export default t.struct(config).opt<any>({
  label: 'Streetscape Assets',
  iconClass: 'fa-road',
  template: Section,
});
